import styled from 'styled-components';
import IconArrowDownOutline from './IconArrowDownOutline';
var IconArrowUpOutline = /*#__PURE__*/styled(IconArrowDownOutline).withConfig({
  displayName: "IconArrowUpOutline",
  componentId: "c11n-8-111-1__sc-eeafzz-0"
})(["transform:rotate(180deg);"]);
export default IconArrowUpOutline;